import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Members from "../pages/members/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/members",
    element: <Members />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;